export class CompanyUser{
   userId:string;
   companyProfileRequestId:string;
   relationship:number;
   crNumber:string;
   companyProfileRequest:any;

}

export class EsbSbcGetActiveDelegationsByDelegateeNatIdReq {
   delegateeIdentityNumber: string;
   operatorID: number;
   clientIPAddress: string;
   lang: string;
 }

 export class Delegator {
   isEntity: boolean;
   birthDate: Date; // TypeScript Date corresponds to C# DateTime
   email: string;
   phoneNumber: string;
   fullNameArabic: string;
   fullNameEnglish: string;
   identityNumber: string;
   type: DelegatorType; // Reference to DelegatorType interface
   nationality: any; // Use 'any' for optional fields with unknown types
 }
 
 export class ListOfDelegation {
   delegator: Delegator;
   delegationID: number;
   delegationStartDate: Date; // TypeScript Date corresponds to C# DateTime
   delegationEndDate: Date; // TypeScript Date corresponds to C# DateTime
   services: Service[]; // Array of Service objects
 }
 
 export class EsbSbcGetActiveDelegationsByDelegateeNatIdRes {
   listOfDelegations: ListOfDelegation[]; // Array of ListOfDelegation objects
   requestTimestamp: Date; // TypeScript Date corresponds to C# DateTime
   responseTimestamp: Date; // TypeScript Date corresponds to C# DateTime
 }
 
 export class Service {
   id: string;
   arabicName: string;
   englishName: string;
   referenceNumber: string;
 }
 
 export class DelegatorType {
   typeID: number;
   englishName: string;
   arabicName: string;
 }
 